import { ModelBase } from '../../core/model/model-base';
import { MoneyLike } from '../../core/model/money';

export class InvoiceAccounting extends ModelBase {
  constructor() {
    super();
  }

  accountName: string;
  accountNumber: string;
  businessTransactionDate: string;
  costPlace: string;
  costBearer: string;
  counterpart: string;
  creationDate: string;
  credit: string;
  creditAmount: MoneyLike | null;
  debit: string;
  debitAmount: MoneyLike | null;
  function: string;
  project: string;
  verificationDescription: string;
  verificationNumber: string;
}

export class InvoiceAccountingBalance extends ModelBase {
  constructor() {
    super();
  }

  accountName: string;
  accountNumber: string;
  costPlace: string;
  costBearer: string;
  counterpart: string;
  creationDate: string;
  credit: string;
  creditAmount: MoneyLike | null;
  debit: string;
  debitAmount: MoneyLike | null;
  function: string;
  project: string;
}
